import { makeStyles } from '~/UIKit/Style';

export const EventScheduleTimeSeriesEditorStyles = makeStyles((theme) => ({
  TimeSeriesEditorRoot: {
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      display: 'flex',
      justifyContent: 'space-around',
      flexFlow: 'wrap',
      '& > div': {
        width: '48%',
        padding: '0 !important',

        '&:last-of-type': {
          marginLeft: 'auto',
        },
      },
    },
  },
  eventScheduleTimeSeriesEditorTooltipContent: {
    lineHeight: '21px',
  },
}));
